// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  text-align: center;
  background-color: #fafafa;
  color: #333;
  padding: 1rem;
}

.error-content {
  max-width: 500px;
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.error-title {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  color: #d32f2f;
}

.error-message {
  font-size: 1.1rem;
  margin-bottom: 1.5rem;
  color: #555;
}

.error-button {
  cursor: pointer;
  padding: 0.75rem 1.5rem;
  background-color: #1976d2;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  transition: background-color 0.3s ease;
}

.error-button:hover {
  background-color: #1565c0;
}

.error-button:focus {
  outline: 2px solid #90caf9;
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Error.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":[".error-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 80vh;\r\n  text-align: center;\r\n  background-color: #fafafa;\r\n  color: #333;\r\n  padding: 1rem;\r\n}\r\n\r\n.error-content {\r\n  max-width: 500px;\r\n  background: #fff;\r\n  padding: 2rem;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\r\n}\r\n\r\n.error-title {\r\n  font-size: 2rem;\r\n  margin-bottom: 0.5rem;\r\n  color: #d32f2f;\r\n}\r\n\r\n.error-message {\r\n  font-size: 1.1rem;\r\n  margin-bottom: 1.5rem;\r\n  color: #555;\r\n}\r\n\r\n.error-button {\r\n  cursor: pointer;\r\n  padding: 0.75rem 1.5rem;\r\n  background-color: #1976d2;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.error-button:hover {\r\n  background-color: #1565c0;\r\n}\r\n\r\n.error-button:focus {\r\n  outline: 2px solid #90caf9;\r\n  outline-offset: 2px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
